import type { ScientificAnalysis } from '../types/analysis';

const STORAGE_KEY = 'conectar-scientific-analysis';

const defaultAnalyses: ScientificAnalysis[] = [
  {
    id: 'an-1',
    title: 'Comparação Oficina × Implantação',
    types: ['comparativa', 'correlacional'],
    researchObjectives: ['comparacao_contextos', 'impacto_comunicacao'],
    eventIds: ['evt-1', 'evt-2'],
    createdBy: 'pesquisa@conectar.app',
    collaboratorEmails: ['pesquisa@conectar.app'],
    createdAt: '2025-10-05T10:00:00Z',
    status: 'concluida',
  },
  {
    id: 'an-2',
    title: 'Correlação rotinas e jogos — visitas semanais',
    types: ['correlacional', 'evolutiva'],
    researchObjectives: ['engajamento_uso', 'evolucao_aprendizagem'],
    eventIds: ['evt-3', 'evt-4'],
    createdBy: 'prof.lucia@conectar.app',
    collaboratorEmails: ['prof.lucia@conectar.app', 'pesquisa@conectar.app'],
    createdAt: '2025-11-20T14:00:00Z',
    status: 'rascunho',
  },
];

function migrateAnalysis(raw: Record<string, unknown>): ScientificAnalysis {
  return {
    id: raw.id as string,
    title: raw.title as string,
    types: Array.isArray(raw.types)
      ? (raw.types as string[]).filter(Boolean) as ScientificAnalysis['types']
      : raw.type
        ? [raw.type as ScientificAnalysis['types'][number]]
        : ['descritiva'],
    customTypeLabel: raw.customTypeLabel as string | undefined,
    researchObjectives: Array.isArray(raw.researchObjectives)
      ? (raw.researchObjectives as string[]).filter(Boolean) as ScientificAnalysis['researchObjectives']
      : raw.researchObjective
        ? [raw.researchObjective as ScientificAnalysis['researchObjectives'][number]]
        : [],
    eventIds: (raw.eventIds as string[]) ?? [],
    createdBy: (raw.createdBy as string) ?? '',
    collaboratorEmails: (raw.collaboratorEmails as string[]) ?? [],
    createdAt: (raw.createdAt as string) ?? new Date().toISOString(),
    status: (raw.status as 'rascunho' | 'concluida') ?? 'rascunho',
  };
}

export function loadAnalyses(): ScientificAnalysis[] {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (raw) {
      const parsed = JSON.parse(raw) as Record<string, unknown>[];
      return parsed.map(migrateAnalysis);
    }
  } catch {
    /* defaults */
  }
  return defaultAnalyses;
}

export function saveAnalyses(analyses: ScientificAnalysis[]) {
  localStorage.setItem(STORAGE_KEY, JSON.stringify(analyses));
}
